import React from 'react';
import PropTypes from 'prop-types';
import {
	Button,
	makeStyles,
	Typography
} from '@material-ui/core';

const styles = makeStyles(theme => ({
	root: {
		textTransform: "none",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "inline-block",
		justifyContent: "flex-start",
		width: '100%',

		"&$disabled": {
			paddingBottom: "0px !important",
			color: `${theme.palette.grey[700]} !important`
		}
	},

	disabled: {},

	label: {
		textAlign: "left"
	},

	name: {
		whiteSpace: 'normal',
		wordWrap: 'break-word'
	},

	ipAddress: {
		fontSize: "0.95rem"
	}
}));

function AuthorLink(props) {
	let classes = styles(),
		{name, sourceHandle, twoLines, link, ip} = props,
		isCall = link && link.indexOf("tel:") === 0,
		isEmail = link && link.indexOf("mailto:") === 0,
		target = !(isEmail || isCall) ? "_blank" : "",
		suffix = isCall ? <span><br/>{link.substring(4)}</span> : isEmail ? <span><br/>{link.substring(7)}</span> : null;

	// show ip address if name or sourceHandle is undefined
	let showIp = (!name || !sourceHandle) && ip;
	return (
		<Button
			size="small"
			fullWidth={!twoLines}
			href={link}
			target={target}
			disabled={!link}
			classes={{
				root: classes.root,
				disabled: classes.disabled,
				label: classes.label
			}}>
			<b className={classes.name}>{name}</b>{suffix}
			{twoLines ? <br/> : " "}
			{sourceHandle}

			{showIp && 
				<Typography color="textSecondary" className={classes.ipAddress}>IP Address: {ip}</Typography>
			}
		</Button>
	);
}


AuthorLink.propTypes = {
	name: PropTypes.string,
	link: PropTypes.string,
	sourceHandle: PropTypes.string,
	twoLines: PropTypes.bool
};

export default AuthorLink;
